import { render, staticRenderFns } from "./SellerDetailsStep4.vue?vue&type=template&id=4951693c&scoped=true"
import script from "./SellerDetailsStep4.vue?vue&type=script&lang=js"
export * from "./SellerDetailsStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951693c",
  null
  
)

export default component.exports